import React from "react";
import { formatMinutes } from "../../../../app/datetimeUtils";
import { scrollToSection } from "../../../../app/useScrollToSection";
import { UsageFilteredByCourseViewModel } from "./UsageFilteredByCourseViewModel";
import {
	USAGE_WRITING,
	USAGE_WRITING_CR,
	USAGE_PEER_REVIEWS,
	USAGE_LESSONS,
	USAGE_LESSONS_ASSIGNED,
} from "./UsageReport";

export function UsageSummaryTable(props: {
	className?: string;
	data: UsageFilteredByCourseViewModel;
	assignedLessonTimeMinutes: number;
}) {
	const { data, assignedLessonTimeMinutes } = props;
	return (
		<table className={`tbl-usage ${props.className}`}>
			<colgroup>
				<col className="mr-4" />
				<col className="w-28 mr-12" />
				<col />
				<col className="w-28" />
			</colgroup>
			<tbody>
				<tr>
					<th className="link" onClick={() => scrollToSection(USAGE_WRITING)}>
						Number of Essays
					</th>
					<td>{data.writingUsageTotalForCourse.essayCount}</td>
					<th className="link" onClick={() => scrollToSection(USAGE_WRITING_CR)}>
						Constructed Response Essays
					</th>
					<td>{data.constructedResponseUsageTotalForCourse.essayCount}</td>
				</tr>
				<tr>
					<th>Number of Drafts</th>
					<td>{data.writingUsageTotalForCourse.draftCount}</td>
					<th>Constructed Response Drafts</th>
					<td>{data.constructedResponseUsageTotalForCourse.draftCount}</td>
				</tr>
				<tr>
					<th>Drafts Per Essay</th>
					<td>{data.writingUsageTotalForCourse.draftPerEssayAverageCount}</td>
					<th>Drafts Per Constructed Response</th>
					<td>{data.constructedResponseUsageTotalForCourse.draftPerEssayAverageCount}</td>
				</tr>
				<tr className="tbl-usage-section">
					<th className="link" onClick={() => scrollToSection(USAGE_PEER_REVIEWS)}>
						Peer Reviews Written
					</th>
					<td>{data.peerReviews.length}</td>
					<th />
					<td />
				</tr>
				<tr className="tbl-usage-section">
					<th className="link" onClick={() => scrollToSection(USAGE_LESSONS)}>
						Lesson Usage
					</th>
					<td>{formatMinutes(data.tutorialUsageForCourse.timeSpentMinutes)}</td>
					<th className="link" onClick={() => scrollToSection(USAGE_LESSONS_ASSIGNED)}>
						Assigned Lesson Usage
					</th>
					<td>{formatMinutes(assignedLessonTimeMinutes)}</td>
				</tr>
			</tbody>
		</table>
	);
}
